module.exports = __webpack_public_path__ + "img/preloader-white.70e343ac.svg";